import React from "react";
import { Steps } from "./steps";
import { Message } from "./components";
import { Grid, Box } from "@material-ui/core";
import { Context } from "./context";
import { useQueryParam } from "@hooks";

export const Request: React.FC = () => {
  const draft = useQueryParam("draft");

  return (
    <React.Fragment>
      <Context draft={draft}>
        <Grid container spacing={2}>
          <Grid item xs={3} component={Box}>
            <Message />
          </Grid>
          <Grid item xs={9} component={Box}>
            <Steps />
          </Grid>
        </Grid>
      </Context>
    </React.Fragment>
  );
};
